import { render, staticRenderFns } from "./QuestionAnswers.vue?vue&type=template&id=b65c7c6e&"
import script from "./QuestionAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswers.vue?vue&type=style&index=0&id=b65c7c6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports